
<template>
  <div class='bottomview' >
    <!-- 底部 -->
    <div class="home_bottom">
      <div class="home_bottom_top">
        <div class="bottom_left">
          <img src="@/assets/dianhua@2x.png" alt="">
          <div>
            <span>客服热线（9:30-18:00）</span>
            <span>0571-82630806</span>
          </div>
        </div>
        <div class="bottom_right">
          <div class="right_one">
            <span><router-link to="/home?id=1">首页</router-link></span>
            <span><router-link to="/rent?id=2">租将军介绍</router-link></span>
            <span><router-link to="/product?id=3">产品介绍</router-link></span>
            <span><router-link to="/contact?id=4">联系我们</router-link></span>
          </div>
          <div class="right_two"></div>
          <div class="right_three">地址：浙江省杭州市萧山区金城路458号国际商务中心1幢1401室</div>
        </div>
      </div>
      <div class="home_bottom_bot">
        <div><a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">浙ICP备2022007576号</a></div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  /* eslint-disable */
  name: 'Bottom',
  components: {},
  data() {
    return {
      hrefT: 11
    }
  },
  mounted () {

  },

}
</script>

<style lang="less">
.home_bottom {
  color: #b9b8b8;
  width: 100%;
  height: 16.3rem;
  // background: #979797;
  background: #333;
  border: 1px solid #979797;
  // text-align: center;
  position: relative;
  .home_bottom_top {
    width: 100%;
    height: 99%;
    display: inline-flex;
    flex-direction: row;
    justify-content: space-evenly;
    margin: auto;
    font-size: 0.85rem;
    span:hover{
      cursor:pointer;
    }
    .bottom_left{
      flex: 1;
      // background-color: #fff;
      position: relative;
      img{
        width: 2.2rem;
        height: 2.35rem;
        position: absolute;
        top: 6.2rem;  
        // top: calc(50% - 5.7rem);
        left: 12.5rem;
      }
      span:nth-child(1){
        font-size: 0.8rem;
        position: absolute;
        top: 5.85rem;
        left: 16.4rem;
        
      }
      span:nth-child(2){
        font-size: 1.2rem;
        position: absolute;
        top: 7.3rem;
        left: 16.4rem;
      }
    }
    .bottom_right{
      flex: 1;
      font-size: 0.9rem;
      color: #fff;
      .right_one{
        margin: 3.5rem 0 0 0.5rem;
        flex-direction: column;
        span{
          margin-right: 3.25rem;
          a{
            color: #fff;
          }
        }
      }
      .right_two{
        margin: 2.3rem 0 0 0.5rem;
      }
      .right_three{
        margin: 0.8rem 0 0 0.5rem;
      }
      .right_two,.right_three:hover{
        cursor:pointer;
      }
    }
  }
  .home_bottom_bot {
    width: 100%;
    padding: 1.1rem 0;
    position: absolute;
    bottom: 0;
    background-color: #000;
    div {
      font-size: 0.9rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffffd7;
      // line-height: 2.2rem;
      text-align: center;
      a{
        color: #ffffffd7;
      }
    }
  }
}
</style>
